import { UserButton, useClerk, useUser } from '@clerk/clerk-react'
import { AccountWidget } from '@loop3/ui'

/**
 * Sidebar-footer account widget: avatar, name/email, and a settings button
 * that opens Clerk's user-profile modal. Canonical copy — was previously
 * duplicated verbatim across every app's `AppSidebar`.
 */
export function AccountSection() {
  const { user, isLoaded } = useUser()
  const { openUserProfile } = useClerk()
  return (
    <AccountWidget
      avatar={<UserButton appearance={{ elements: { avatarBox: 'size-7 rounded-full' } }} />}
      name={user?.fullName ?? user?.firstName ?? user?.username ?? null}
      email={user?.primaryEmailAddress?.emailAddress ?? null}
      onSettingsClick={() => openUserProfile()}
      isLoading={!isLoaded}
    />
  )
}
